module.exports = __webpack_public_path__ + "marriott-mockup.3026s7ZV.png";